import _ from 'lodash';

function serialize(obj, prefix) {
  const str = [];
  Object.keys(obj).forEach((p) => {
    let k = p;
    const v = obj[p];
    if (prefix) {
      if (_.isObject(v) || !k.match(/\d+/)) {
        k = `${prefix}[${p}]`;
      } else {
        k = `${prefix}[]`;
      }
    }
    str.push((v !== null && _.isObject(v))
      ? serialize(v, k)
      : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
  });
  if (!str.length) {
    return '';
  }

  return str.join('&');
}

const emptyValue = (value) => {
  const emptyObject = _.isObject(value) && _.isEmpty(value);
  if (value === undefined || value === null || emptyObject) {
    return true;
  }
  return false;
};

const sanitize = (object) => {
  if (!_.isObject(object) || _.isArray(object)) {
    return object;
  }

  const sanitized = {};
  _.forOwn(object, (value, key) => {
    const sanitizedValue = sanitize(value);
    if (!emptyValue(sanitizedValue)) {
      sanitized[key] = sanitizedValue;
    }
  });

  return sanitized;
};

export function buildURL(endpoint, id, action, params) {
  const queryParams = _.merge(sanitize(params), _.get(params, '_literal', {}));
  delete queryParams._literal; // eslint-disable-line
  const baseEndpoint = `${endpoint}${id ? `/${id}` : ''}${action ? `/${action}` : ''}`;
  const serializedQueryParams = serialize(queryParams);

  return `${baseEndpoint}${serializedQueryParams ? `?${serializedQueryParams}` : ''}`;
}

export const mergeIfPresent = (obj, elem, diff) => (
  _.isEmpty(elem) ? obj : _.merge({}, obj, diff(elem))
);
